class DebugScene extends Phaser.Scene {
    constructor() {
        super({ key: 'DebugScene' });
    }

    create() {
        const style = {
            fontFamily: 'pixelify, Arial, sans-serif',
            fontSize: '14px',
            color: '#00ff00',
            backgroundColor: '#000000aa',
            padding: {
                x: 8,
                y: 4
            }
        };

        this.sceneText = this.add.text(10, 10, '', style);
        this.textureText = this.add.text(10, 300, '', style);
        this.audioText = this.add.text(250, 300, '', style);
        this.memoryText = this.add.text(500, 300, '', style);

        this.sceneText.setScrollFactor(0);
        this.textureText.setScrollFactor(0);
        this.audioText.setScrollFactor(0);
        this.memoryText.setScrollFactor(0);

        this.scene.bringToTop();

        this.time.addEvent({
            delay: 500,
            loop: true,
            callback: this.refresh,
            callbackScope: this
        });

        this.refresh();
    }

    refresh() {
        this.updateScenes();
        this.updateTextures();
        this.updateAudio();
        this.updateMemory();
    }

    updateScenes() {
        const scenes = this.scene.manager.scenes;

        const list = scenes.map(scene => {
            let state = 'inactive';

            if (scene.scene.isActive()) {
                state = 'active';
            }

            if (scene.scene.isPaused()) {
                state = 'paused';
            }

            if (scene.scene.isSleeping()) {
                state = 'sleeping';
            }

            return `${scene.scene.key} [${state}]`;
        });

        this.sceneText.setText([
            '=== SCENES ===',
            ...list
        ]);
    }

    updateTextures() {
        const keys = this.textures.getTextureKeys();

        this.textureText.setText([
            `=== TEXTURES (${keys.length}) ===`,
            ...keys
        ]);
    }

    updateAudio() {
        const keys = this.cache.audio.getKeys();

        this.audioText.setText([
            `=== AUDIO (${keys.length}) ===`,
            ...keys
        ]);
    }

    updateMemory() {
        const mem = performance.memory;

        if (!mem) {
            this.memoryText.setText([
                '=== MEMORY ===',
                'Not supported'
            ]);
            return;
        }

        const usedMB = (mem.usedJSHeapSize / 1024 / 1024).toFixed(1);
        const totalMB = (mem.totalJSHeapSize / 1024 / 1024).toFixed(1);
        const maxMB = (mem.jsHeapSizeLimit / 1024 / 1024).toFixed(1);

        this.memoryText.setText([
            '=== MEMORY ===',
            `Used: ${usedMB} MB`,
            `Allocated: ${totalMB} MB`,
            `Max: ${maxMB} MB`
        ]);
    }
}

export default DebugScene;